import React, { useState } from "react";

const Gallery = () => {
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [mediaType, setMediaType] = useState(null);
  const [videoPlaying, setVideoPlaying] = useState(false);

  // Data gallery dengan tipe media
  const galleryItems = [
    {
      id: 9,
      category: "profile",
      title: "Profile Video",
      type: "video",
      source: "/profilevideo.mp4",
      thumbnail: "/LogoCAI.svg",
      aos: "fade-up",
    },
    {
      id: 1,
      category: "product",
      title: "Premium Patchouli Oil",
      type: "image",
      source: "/galery5.jpeg",
      thumbnail: "/galery5.jpeg",
      aos: "fade-up",
    },
    {
      id: 2,
      category: "product",
      title: "Premium Patchouli Oil",
      type: "image",
      source: "/galery7.jpeg",
      thumbnail: "/galery7.jpeg",
      aos: "fade-up",
    },
    {
      id: 3,
      category: "product",
      title: "Premium Patchouli Oil",
      type: "image",
      source: "/galery8.jpeg",
      thumbnail: "/galery8.jpeg",
      aos: "fade-up",
    },
    {
      id: 4,
      category: "product",
      title: "Premium Patchouli Oil",
      type: "image",
      source: "/galery10.jpeg",
      thumbnail: "/galery10.jpeg",
      aos: "fade-up",
    },
    {
      id: 5,
      category: "team",
      title: "Our Team",
      type: "image",
      source: "/galery11.jpeg",
      thumbnail: "/galery11.jpeg",
      aos: "fade-up",
    },
    {
      id: 6,
      category: "product",
      title: "Premium Patchouli Oil",
      type: "image",
      source: "/galery12.jpeg",
      thumbnail: "/galery12.jpeg",
      aos: "fade-up",
    },
    {
      id: 7,
      category: "product",
      title: "Premium Patchouli Oil",
      type: "image",
      source: "/galery13.jpeg",
      thumbnail: "/galery13.jpeg",
      aos: "fade-up",
    },
    {
      id: 8,
      category: "product",
      title: "Premium Patchouli Oil",
      type: "image",
      source: "/galery14.jpeg",
      thumbnail: "/galery14.jpeg",
      aos: "fade-up",
    },
    {
      id: 10,
      category: "team",
      title: "team",
      type: "image",
      source: "/team/6.jpeg",
      thumbnail: "/team/6.jpeg",
      aos: "fade-up",
    },
    {
      id: 11,
      category: "team",
      title: "team",
      type: "image",
      source: "/team/7.jpeg",
      thumbnail: "/team/7.jpeg",
      aos: "fade-up",
    },
    {
      id: 12,
      category: "team",
      title: "team",
      type: "image",
      source: "/team/8.jpeg",
      thumbnail: "/team/8.jpeg",
      aos: "fade-up",
    },
    {
      id: 13,
      category: "team",
      title: "team",
      type: "image",
      source: "/team/9.jpeg",
      thumbnail: "/team/9.jpeg",
      aos: "fade-up",
    },
    {
      id: 14,
      category: "team",
      title: "team",
      type: "image",
      source: "/team/11.jpeg",
      thumbnail: "/team/11.jpeg",
      aos: "fade-up",
    },
    {
      id: 15,
      category: "farmer",
      title: "farmer",
      type: "image",
      source: "/petani/5.jpeg",
      thumbnail: "/petani/5.jpeg",
      aos: "fade-up",
    },
    {
      id: 16,
      category: "farmer",
      title: "farmer",
      type: "image",
      source: "/petani/6.jpeg",
      thumbnail: "/petani/6.jpeg",
      aos: "fade-up",
    },
  ];

  // Kategori filter
  const categories = [
    { id: "all", label: "All" },
    { id: "product", label: "Product" },
    { id: "team", label: "Team" },
    { id: "profile", label: "Profile" },
    { id: "farmer", label: "Farmer" },
  ];

  const [activeCategory, setActiveCategory] = useState("all");

  // Filter items berdasarkan kategori
  const filteredItems =
    activeCategory === "all"
      ? galleryItems
      : galleryItems.filter((item) => item.category === activeCategory);

  // Handle modal
  const openModal = (item) => {
    setSelectedMedia(item);
    setMediaType(item.type);
    setVideoPlaying(false); // Reset video playing state
  };

  const closeModal = () => {
    setSelectedMedia(null);
    setMediaType(null);
    setVideoPlaying(false);
  };

  // Fungsi untuk mendapatkan icon berdasarkan tipe media
  const getMediaIcon = (type) => {
    if (type === "video") {
      return (
        <div
          className="position-absolute top-50 start-50 translate-middle"
          style={{
            backgroundColor: "rgba(182, 139, 64, 0.9)",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: "20px",
            zIndex: 2,
            boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
          }}
        >
          ▶
        </div>
      );
    }
    return null;
  };

  return (
    <section
      id="gallery"
      className="py-5"
      style={{
        backgroundColor: "#ffffff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background Decoration */}
      <div
        className="position-absolute"
        style={{
          top: "-10%",
          right: "-5%",
          width: "min(400px, 50vw)",
          height: "min(400px, 50vw)",
          background:
            "radial-gradient(circle, rgba(182,139,64,0.03) 0%, transparent 70%)",
          borderRadius: "50%",
          zIndex: 0,
        }}
      />
      <div
        className="position-absolute"
        style={{
          bottom: "-10%",
          left: "-5%",
          width: "min(400px, 50vw)",
          height: "min(400px, 50vw)",
          background:
            "radial-gradient(circle, rgba(26,62,63,0.03) 0%, transparent 70%)",
          borderRadius: "50%",
          zIndex: 0,
        }}
      />

      <div className="container position-relative" style={{ zIndex: 1 }}>
        {/* Section Header */}
        <div className="text-center mb-5" data-aos="fade-down">
          <h5
            className="text-uppercase mb-3"
            style={{
              color: "#b68b40",
              fontSize: "clamp(0.9rem, 2vw, 1rem)",
              fontWeight: "600",
              letterSpacing: "4px",
            }}
          >
            Our Gallery
          </h5>
          <h2
            style={{
              color: "#1a3e3f",
              fontSize: "clamp(2rem, 5vw, 2.5rem)",
              fontWeight: "700",
              marginBottom: "15px",
            }}
          >
            A Glimpse Into Our World
          </h2>
          <p
            className="mx-auto"
            style={{
              color: "#6c757d",
              fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
              maxWidth: "700px",
            }}
          >
            Explore our products, team, and videos
          </p>
          <div
            className="mx-auto"
            style={{
              width: "60px",
              height: "3px",
              background: "#b68b40",
              marginTop: "20px",
              borderRadius: "2px",
            }}
          />
        </div>

        {/* Category Filter */}
        <div
          className="d-flex justify-content-center gap-2 gap-md-3 flex-wrap mb-5"
          data-aos="fade-up"
        >
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className="btn rounded-pill px-4 py-2"
              style={{
                backgroundColor:
                  activeCategory === category.id ? "#b68b40" : "transparent",
                color: activeCategory === category.id ? "white" : "#1a3e3f",
                border:
                  activeCategory === category.id
                    ? "2px solid #b68b40"
                    : "2px solid #1a3e3f",
                fontSize: "clamp(0.9rem, 2vw, 1rem)",
                fontWeight: "600",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                if (activeCategory !== category.id) {
                  e.currentTarget.style.backgroundColor = "#1a3e3f";
                  e.currentTarget.style.color = "white";
                  e.currentTarget.style.borderColor = "#1a3e3f";
                }
              }}
              onMouseLeave={(e) => {
                if (activeCategory !== category.id) {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "#1a3e3f";
                  e.currentTarget.style.borderColor = "#1a3e3f";
                }
              }}
            >
              {category.label}
            </button>
          ))}
        </div>

        {/* Gallery Grid dengan Video Support */}
        <div className="row g-3 g-md-4">
          {filteredItems.map((item, index) => (
            <div
              key={item.id}
              className="col-6 col-sm-4 col-md-3"
              data-aos={item.aos}
              data-aos-delay={index * 50}
            >
              <div
                className="position-relative overflow-hidden rounded-3 shadow-sm"
                style={{
                  aspectRatio: "1/1",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  backgroundColor: "#f8f9fa",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow =
                    "0 15px 30px rgba(26,62,63,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 5px 15px rgba(0,0,0,0.1)";
                }}
                onClick={() => openModal(item)}
              >
                {/* Thumbnail */}
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-100 h-100"
                  style={{
                    objectFit: "cover",
                  }}
                  onError={(e) => {
                    e.target.src =
                      "https://via.placeholder.com/400x400?text=Media+Not+Found";
                  }}
                />

                {/* Video Icon Overlay untuk video items */}
                {getMediaIcon(item.type)}

                {/* Category Badge */}
                <div
                  className="position-absolute top-0 end-0 m-2 px-2 py-1 rounded-pill"
                  style={{
                    backgroundColor: "rgba(26,62,63,0.8)",
                    color: "white",
                    fontSize: "clamp(0.7rem, 1.5vw, 0.8rem)",
                    opacity: 0,
                    transition: "opacity 0.3s ease",
                    zIndex: 3,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = 1;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = 0;
                  }}
                >
                  {item.category}
                </div>

                {/* Type Badge */}
                <div
                  className="position-absolute top-0 start-0 m-2 px-2 py-1 rounded-pill"
                  style={{
                    backgroundColor:
                      item.type === "video"
                        ? "rgba(182,139,64,0.9)"
                        : "rgba(52,152,219,0.8)",
                    color: "white",
                    fontSize: "clamp(0.7rem, 1.5vw, 0.8rem)",
                    textTransform: "uppercase",
                    zIndex: 3,
                  }}
                >
                  {item.type}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {filteredItems.length === 0 && (
          <div className="text-center py-5">
            <p className="text-secondary fs-5">
              No items found in this category
            </p>
          </div>
        )}

        {/* Modal untuk Media dengan Button Play */}
        {selectedMedia && (
          <div
            className="position-fixed top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: "rgba(0,0,0,0.9)",
              zIndex: 9999,
              padding: "20px",
            }}
            onClick={closeModal}
          >
            <div
              className="position-relative"
              style={{
                maxWidth:
                  mediaType === "video"
                    ? "min(1000px, 90vw)"
                    : "min(800px, 90vw)",
                width: "100%",
                maxHeight: "80vh",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {mediaType === "video" ? (
                // Tampilkan Video dengan Play Button
                <div className="position-relative">
                  {!videoPlaying ? (
                    <>
                      {/* Thumbnail */}
                      <img
                        src={selectedMedia.thumbnail}
                        alt={selectedMedia.title}
                        className="w-100 rounded-3"
                        style={{
                          maxHeight: "70vh",
                          objectFit: "cover",
                          cursor: "pointer",
                        }}
                      />

                      {/* Play Button */}
                      <button
                        onClick={() => setVideoPlaying(true)}
                        className="position-absolute top-50 start-50 translate-middle border-0 rounded-circle"
                        style={{
                          width: "80px",
                          height: "80px",
                          backgroundColor: "rgba(182,139,64,0.9)",
                          color: "white",
                          fontSize: "30px",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingLeft: "8px", // Offset for play icon
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#b68b40";
                          e.currentTarget.style.transform =
                            "translate(-50%, -50%) scale(1.1)";
                          e.currentTarget.style.boxShadow =
                            "0 6px 25px rgba(182,139,64,0.4)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor =
                            "rgba(182,139,64,0.9)";
                          e.currentTarget.style.transform =
                            "translate(-50%, -50%) scale(1)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 20px rgba(0,0,0,0.3)";
                        }}
                      >
                        ▶
                      </button>

                      {/* Duration Badge (opsional) */}
                      <div
                        className="position-absolute bottom-0 end-0 m-3 px-3 py-1 rounded-pill"
                        style={{
                          backgroundColor: "rgba(0,0,0,0.7)",
                          color: "white",
                          fontSize: "0.9rem",
                        }}
                      >
                        02:30
                      </div>
                    </>
                  ) : // Video Playing
                  selectedMedia.source.includes("youtube") ||
                    selectedMedia.source.includes("vimeo") ? (
                    <div className="ratio ratio-16x9">
                      <iframe
                        src={`${selectedMedia.source}?autoplay=1`}
                        title={selectedMedia.title}
                        allowFullScreen
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        style={{
                          border: "none",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                  ) : (
                    <video
                      controls
                      autoPlay
                      className="w-100 rounded-3"
                      style={{
                        maxHeight: "70vh",
                        backgroundColor: "#000",
                      }}
                      poster={selectedMedia.thumbnail}
                    >
                      <source src={selectedMedia.source} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                </div>
              ) : (
                // Tampilkan Image
                <img
                  src={selectedMedia.source}
                  alt={selectedMedia.title}
                  className="w-100 h-100 rounded-3"
                  style={{
                    objectFit: "contain",
                    maxHeight: "70vh",
                  }}
                  onError={(e) => {
                    e.target.src =
                      "https://via.placeholder.com/800x600?text=Image+Not+Found";
                  }}
                />
              )}

              {/* Close Button */}
              <button
                onClick={closeModal}
                className="position-absolute border-0 bg-transparent"
                style={{
                  top: "-40px",
                  right: "0",
                  color: "white",
                  fontSize: "clamp(1.5rem, 4vw, 2rem)",
                  cursor: "pointer",
                  padding: "10px",
                  transition: "color 0.3s ease",
                  lineHeight: "1",
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#b68b40";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "white";
                }}
              >
                ✕
              </button>

              {/* Title */}
              <div
                className="position-absolute"
                style={{
                  bottom: "-40px",
                  left: "0",
                  color: "white",
                  fontSize: "clamp(0.9rem, 2vw, 1rem)",
                  fontWeight: "500",
                }}
              >
                {selectedMedia.title}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
